import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from './SelectFilter'

interface RebatePeriodFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const RebatePeriodFilter: React.FC<RebatePeriodFilterProps> = ({
  filter,
  onFilterChange,
}) => {
  const { ibRebatesPeriods } = useAppSelector(({ partnerships }) => partnerships)

  const data = ibRebatesPeriods.map((item) => ({ id: item.id, label: item.name, value: item.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
